// The legacy picker uses document coordinates and can place an upward popup
// above the viewport. Bound every move, including Custom Range expansion.
export const constrainDateRangePopup = (picker, topOffset) => {
  if (picker.viewportMoveInstalled) {
    picker.move();
    return;
  }
  const originalMove = picker.move;
  picker.move = function () {
    const topEdge = topOffset + 8;
    const bottomEdge = window.innerHeight - 8;
    this.container.css({
      maxHeight: Math.max(0, bottomEdge - topEdge),
      overflowY: "auto",
      boxSizing: "border-box",
      marginTop: 0,
    });
    originalMove.call(this);
    if (this.container.css("display") === "none") return;
    // move() measures height before setting the final horizontal alignment.
    // On the first opening (or Custom Range expansion), that stale height
    // can place the popup too high. Measure again after its width settles and
    // anchor to the trigger instead of retaining the library's stale top.
    const popup = this.container[0].getBoundingClientRect();
    const trigger = this.element[0].getBoundingClientRect();
    const above = trigger.top - popup.height - 8;
    const below = trigger.bottom + 8;
    const fitsAbove = above >= topEdge;
    const fitsBelow = below + popup.height <= bottomEdge;
    const preferred = this.drops === "up"
      ? (fitsAbove || !fitsBelow ? above : below)
      : (fitsBelow || !fitsAbove ? below : above);
    const top = Math.max(topEdge, Math.min(preferred, bottomEdge - popup.height));
    this.container.css({ top: top + window.scrollY });
  };
  picker.viewportMoveInstalled = true;
  picker.move();
};
